@if (isImage) {
  <div class="pdf-view__image">
    <img [src]="imageSrc" />
  </div>
} @else {
  <ngx-extended-pdf-viewer
    class="pdf-view__pdf"
    [src]="pdfSrc"
    [showToolbar]="false"
    [textLayer]="true"
    [zoom]="'page-fit'"
    [height]="'100%'" />
}
